import { Ref } from 'react';

export const setRef = <T>(outerRef: Ref<T> | undefined, el: T): void => {
  if (outerRef == null) {
    return;
  }
  if (typeof outerRef === 'object') {
    outerRef.current = el;
  } else {
    outerRef(el);
  }
};
